export default __webpack_public_path__ + "static/media/icon-media-sync.7439a0b6.svg";